module.exports = __webpack_public_path__ + "static/media/galleria6.346cfbdb.jpg";